import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationCityActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/City/CityBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationCity"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationCity"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationCityActivity)
